/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamConstancyWorkStepDto } from './BeamConstancyWorkStepDto';
import {
    BeamConstancyWorkStepDtoFromJSON,
    BeamConstancyWorkStepDtoFromJSONTyped,
    BeamConstancyWorkStepDtoToJSON,
} from './BeamConstancyWorkStepDto';
import type { GuidItemGroupDto } from './GuidItemGroupDto';
import {
    GuidItemGroupDtoFromJSON,
    GuidItemGroupDtoFromJSONTyped,
    GuidItemGroupDtoToJSON,
} from './GuidItemGroupDto';
import type { InstructionDto } from './InstructionDto';
import {
    InstructionDtoFromJSON,
    InstructionDtoFromJSONTyped,
    InstructionDtoToJSON,
} from './InstructionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';
import type { WorkItemSource } from './WorkItemSource';
import {
    WorkItemSourceFromJSON,
    WorkItemSourceFromJSONTyped,
    WorkItemSourceToJSON,
} from './WorkItemSource';

/**
 * 
 * @export
 * @interface BeamConstancyWorkItemDto
 */
export interface BeamConstancyWorkItemDto {
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkItemDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkItemDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    taskInJobId?: string;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    taskId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    taskAreaId?: string;
    /**
     * 
     * @type {Array<GuidItemGroupDto>}
     * @memberof BeamConstancyWorkItemDto
     */
    supportSystemIds?: Array<GuidItemGroupDto> | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof BeamConstancyWorkItemDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    description?: string | null;
    /**
     * 
     * @type {InstructionDto}
     * @memberof BeamConstancyWorkItemDto
     */
    instruction?: InstructionDto;
    /**
     * 
     * @type {WorkItemSource}
     * @memberof BeamConstancyWorkItemDto
     */
    source?: WorkItemSource;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    commentEntityCompositeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkItemDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkItemDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof BeamConstancyWorkItemDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<BeamConstancyWorkStepDto>}
     * @memberof BeamConstancyWorkItemDto
     */
    workSteps?: Array<BeamConstancyWorkStepDto> | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    $type?: BeamConstancyWorkItemDtoTypeEnum;
}


/**
 * @export
 */
export const BeamConstancyWorkItemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoBeamConstancyWorkItemDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BeamConstancyWorkItemDtoTypeEnum = typeof BeamConstancyWorkItemDtoTypeEnum[keyof typeof BeamConstancyWorkItemDtoTypeEnum];


/**
 * Check if a given object implements the BeamConstancyWorkItemDto interface.
 */
export function instanceOfBeamConstancyWorkItemDto(value?: unknown): value is BeamConstancyWorkItemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamConstancyWorkItemDtoTypeEnum)[0];
}

export function BeamConstancyWorkItemDtoFromJSON(json: any): BeamConstancyWorkItemDto {
    return BeamConstancyWorkItemDtoFromJSONTyped(json, false);
}

export function BeamConstancyWorkItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamConstancyWorkItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'taskInJobId': !exists(json, 'taskInJobId') ? undefined : json['taskInJobId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'taskId': !exists(json, 'taskId') ? undefined : json['taskId'],
        'taskAreaId': !exists(json, 'taskAreaId') ? undefined : json['taskAreaId'],
        'supportSystemIds': !exists(json, 'supportSystemIds') ? undefined : (json['supportSystemIds'] === null ? null : (json['supportSystemIds'] as Array<any>).map(GuidItemGroupDtoFromJSON)),
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'taskType': !exists(json, 'taskType') ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'instruction': !exists(json, 'instruction') ? undefined : InstructionDtoFromJSON(json['instruction']),
        'source': !exists(json, 'source') ? undefined : WorkItemSourceFromJSON(json['source']),
        'commentEntityCompositeId': !exists(json, 'commentEntityCompositeId') ? undefined : json['commentEntityCompositeId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'workSteps': !exists(json, 'workSteps') ? undefined : (json['workSteps'] === null ? null : (json['workSteps'] as Array<any>).map(BeamConstancyWorkStepDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function BeamConstancyWorkItemDtoToJSON(value?: BeamConstancyWorkItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'taskInJobId': value.taskInJobId,
        'name': value.name,
        'taskId': value.taskId,
        'taskAreaId': value.taskAreaId,
        'supportSystemIds': value.supportSystemIds === undefined ? undefined : (value.supportSystemIds === null ? null : (value.supportSystemIds as Array<any>).map(GuidItemGroupDtoToJSON)),
        'iuid': value.iuid,
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        'description': value.description,
        'instruction': InstructionDtoToJSON(value.instruction),
        'source': WorkItemSourceToJSON(value.source),
        'commentEntityCompositeId': value.commentEntityCompositeId,
        'commentCount': value.commentCount,
        'lastComment': value.lastComment,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'workSteps': value.workSteps === undefined ? undefined : (value.workSteps === null ? null : (value.workSteps as Array<any>).map(BeamConstancyWorkStepDtoToJSON)),
        '$type': value.$type,
    });
}

